import api from "./instance";

const OBJECT_ID = /^[a-f\d]{24}$/i;

export const getChat = (_staffId, doctorId) => {
  const id = typeof doctorId === "object" ? doctorId?._id : doctorId;
  if (!OBJECT_ID.test(String(id || ""))) {
    return Promise.resolve({ data: { success: true, messages: [] } });
  }
  return api.post("/staff/getchat", { doctorId: String(id) });
};

export const sendChat = (_staffId, doctorId, payload) => {
  if (payload instanceof FormData) {
    if (!payload.has("doctorId")) payload.append("doctorId", doctorId);
    return api.post("/staff/sendchat", payload, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  }
  return api.post("/staff/sendchat", {
    doctorId,
    message: payload.message,
    senderType: payload.senderType || "staff",
  });
};
